import React from 'react';
import visaLogo from '@/assets/icons/visa.svg';
import mastercardLogo from '@/assets/icons/mastercard.svg';
import applePayLogo from '@/assets/icons/apple-pay.svg';
import googlePayLogo from '@/assets/icons/google-pay.svg';
import paypalLogo from '@/assets/icons/paypal.svg';
import sepaLogo from '@/assets/icons/sepa.svg';
import bankTransferLogo from '@/assets/icons/bank-transfer.svg';

export const VisaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img src={visaLogo} alt="Visa" width={48} height={32} className={className} />
);

export const MastercardIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img src={mastercardLogo} alt="Mastercard" width={48} height={32} className={className} />
);

export const ApplePayIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img src={applePayLogo} alt="Apple Pay" width={48} height={32} className={className} />
);

export const GooglePayIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img src={googlePayLogo} alt="Google Pay" width={48} height={32} className={className} />
);

export const PaypalIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img src={paypalLogo} alt="PayPal" width={48} height={32} className={className} />
);

export const SepaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img src={sepaLogo} alt="SEPA" width={48} height={32} className={className} />
);

export const BankTransferIcon: React.FC<{ className?: string }> = ({ className }) => (
  <img src={bankTransferLogo} alt="Bank Transfer" width={48} height={32} className={className} />
);

// Legacy export for backward compatibility
export const BitcoinIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="32" rx="4" fill="#F7931A"/>
    <path d="M30.5 14.3C30.9 12 29.2 10.7 26.9 9.9L27.6 7.2L26 6.8L25.3 9.4C24.9 9.3 24.4 9.2 24 9.1L24.7 6.5L23.1 6.1L22.4 8.8C22.1 8.7 21.7 8.6 21.4 8.6L19.1 8L18.6 9.7C18.6 9.7 19.8 10 19.8 10C20.4 10.2 20.5 10.6 20.5 10.9L19.7 13.9C19.8 13.9 19.8 13.9 19.9 14L19.7 14C19.7 14 18.9 18 18.6 19.2C18.5 19.5 18.2 19.9 17.6 19.7C17.6 19.7 16.4 19.4 16.4 19.4L15.6 21.3L17.8 21.8C18.2 21.9 18.5 22 18.9 22.1L18.2 24.8L19.8 25.2L20.5 22.5C20.9 22.6 21.3 22.7 21.7 22.8L21 25.5L22.6 25.9L23.3 23.2C26.2 23.7 28.3 23.5 29.2 20.9C29.9 18.8 29.2 17.6 27.6 16.8C28.8 16.5 29.7 15.7 30 14.3H30.5ZM26.1 19.5C25.6 21.6 22.2 20.5 21.1 20.2L22 16.6C23.1 16.9 26.6 17.4 26.1 19.5ZM26.6 14.3C26.2 16.2 23.4 15.2 22.5 15L23.3 11.7C24.2 12 27.1 12.3 26.6 14.3Z" fill="white"/>
  </svg>
);
